import { DaySchedule } from './types';

export const eventSchedule: DaySchedule[] = [
  {
    day: 1,
    name: "Day 1",
    timeSlots: [
      {
        hour: 9,
        displayTime: "9:00 AM",
        events: [
          { id: "1-9-1", name: "Inaugration", description: "Kickstart ASTRANOVA", venue: "AUDITORIUM", type: "technical" },
        ]
      },
      {
        hour: 10,
        displayTime: "10:00 AM",
        events: [
          { id: "1-10-1", name: "Paper Presentation", description: "Showcase your Idea and Research on out platform", venue: "IT 213", type: "technical" },
          { id: "1-10-2", name: "Rapid Coding", description: "Indulge in fierce round of coding and bag a gold coin", venue: "IT 444", type: "technical" }
        ]
      },
      {
        hour: 11,
        displayTime: "11:30 AM",
        events: [
          { id: "1-11-1", name: "Anime Quiz", description: "Prove you are fan of ANIME", venue: "IT 444", type: "non-technical" }        ]
      },
      {
        hour: 12,
        displayTime: "12:00 PM",
        events: [
          { id: "1-12-1", name: "Technical Quiz", description: "Let us know, What you know about tech", venue: "Auditorium", type: "technical" },
	        { id: "1-12-2", name: "Logic and Puzzle Coding", description: "Let us test your brains on our Code Puzzles", venue: "", type: "technical" }

        ]
      },
      {
        hour: 1,
        displayTime: "1:00 PM",
        events: [
          { id: "1-1-1", name: " IPL Auction", description: "Build your team and win the game", venue: "Auditorium", type: "non-technical" }
        ]
      },
      {
        hour: 2,
        displayTime: "2:00 PM",
        events: [
          { id: "1-2-1", name: "Blind Coding", description: "Beleive your guts and solve the problems", venue: "Lab 102", type: "technical" },
          { id: "1-2-2", name: " Squid Game", description: "You always know this Win or Die", venue: "Lab 201", type: "non-technical" }
        ]
      },
      {
        hour: 3,
        displayTime: "3:00 PM",
        events: [
          { id: "1-3-1", name: "Carrom", description: "Lets play the board", venue: "", type: "non-technical" },
        ]
      },
      {
        hour: 4,
        displayTime: "4:00 PM",
        events: [
          ]
      },
      {
        hour: 5,
        displayTime: "5:00 PM",
        events: [
        ]
      },
      {
        hour: 6,
        displayTime: "6:00 PM",
        events: [
         ]
      },
      {
        hour: 7,
        displayTime: "7:00 PM",
        events: [
        ]
      },
      {
        hour: 8,
        displayTime: "8:00 PM",
        events: [
        ]
      }
    ]
  },
  {
    day: 2,
    name: "Day 2 - Creative Carnival",
    timeSlots: [
      {
        hour: 9,
        displayTime: "9:00 AM",
        events: [
          { id: "2-9-1", name: "Code Golf", description: "", venue: "", type: "technical" }
        ]
      },
      {
        hour: 10,
        displayTime: "10:00 AM",
        events: [
          { id: "2-10-1", name: "Hackathon", description: "Display your ideas and projects", venue: "IT 215", type: "technical" },
	  { id: "2-10-2", name: "Seminar", description: "Learn something new", venue: "Auditorium", type: "technical" },
	 { id: "2-10-3", name: "TIK-TIK-TIK", description: "", venue: "", type: "technical" }
        ]
      },
      {
        hour: 11,
        displayTime: "11:00 AM",
        events: [
          { id: "2-11-1", name: "Movies Mania", description: "Diehard fan of movies? Prove it! ", venue: "IT 444", type: "non-technical" }
	 
        ]
      },
      {
        hour: 12,
        displayTime: "12:00 PM",
        events: [
                  ]
      },
      {
        hour: 1,
        displayTime: "1:00 PM",
        events: [

          { id: "2-1-1", name: "Escape Room", description: "", venue: "", type: "non-technical" }
        ]
      },
      {
        hour: 2,
        displayTime: "2:00 PM",
        events: [
	{ id: "2-2-1", name: "Relay Coding", description: "", venue: "", type: "technical" },
          { id: "2-2-2", name: "Workshop", description: "Learn, Expertise and Impeove", venue: "", type: "technical" }
        ]
      },
      {
        hour: 3,
        displayTime: "3:00 PM",
        events: [
          { id: "2-3-1", name: "Treasure Hunt", description: "Hunt the Treasure", venue: " ", type: "non-technical" }
        ]
      },
      {
        hour: 4,
        displayTime: "4:00 PM",
        events: [
         ]
      },
      {
        hour: 5,
        displayTime: "5:00 PM",
        events: [
          ]
      },
      {
        hour: 6,
        displayTime: "6:00 PM",
        events: [
        ]
      },
      {
        hour: 7,
        displayTime: "7:00 PM",
        events: [
        ]
      },
      {
        hour: 8,
        displayTime: "8:00 PM",
        events: [
        ]
      }
    ]
  }
];